<template>
  <div id="workspace-group-detail-view">
    <PVTabs v-model:value="activeTab" lazy>
      <PVTabList>
        <router-link :to="getTabLink(WorkspaceGroupDetailViewTab.USERS)">
          <PVTab :value="WorkspaceGroupDetailViewTab.USERS">
            {{ t('workspaceGroupDetailView.users') }}
          </PVTab>
        </router-link>
        <router-link :to="getTabLink(WorkspaceGroupDetailViewTab.PERMISSIONS)">
          <PVTab :value="WorkspaceGroupDetailViewTab.PERMISSIONS">
            {{ t('workspaceGroupDetailView.permissions') }}
          </PVTab>
        </router-link>
      </PVTabList>
      <PVTabPanels>
        <PVTabPanel :value="WorkspaceGroupDetailViewTab.USERS">
          <workspace-group-users
            :workspace-id="workspaceId"
            :group-id="groupId"
          />
        </PVTabPanel>
        <PVTabPanel :value="WorkspaceGroupDetailViewTab.PERMISSIONS">
          <group-permissions-management
            :workspace-id="workspaceId"
            :group-id="groupId"
          />
        </PVTabPanel>
      </PVTabPanels>
    </PVTabs>
  </div>
</template>

<script lang="ts" setup>
  import { RouteLocationRaw } from 'vue-router';
  import { useI18n } from 'vue-i18n';
  import { Route, routeParams } from '@/routes';
  import { WorkspaceGroupDetailViewTab } from './WorkspaceGroupDetailView.types';
  import { useTabs } from '@/composables/useTabs';
  import WorkspaceGroupUsers from '@/components/WorkspaceGroupUsers/WorkspaceGroupUsers.vue';
  import GroupPermissionsManagement from '@/components/GroupPermissionsManagement/GroupPermissionsManagement.vue';

  const props = defineProps<{
    workspaceId: string;
    groupId: string;
  }>();

  const { t } = useI18n();

  const { activeTab } = useTabs(
    Route.WORKSPACE_GROUP_DETAILS,
    WorkspaceGroupDetailViewTab,
    WorkspaceGroupDetailViewTab.USERS,
  );
  function getTabLink(tab: WorkspaceGroupDetailViewTab): RouteLocationRaw {
    return {
      name: Route.WORKSPACE_GROUP_DETAILS,
      params: {
        [routeParams[Route.WORKSPACE_GROUP_DETAILS].workspaceId]:
          props.workspaceId,
        [routeParams[Route.WORKSPACE_GROUP_DETAILS].groupId]: props.groupId,
        [routeParams[Route.WORKSPACE_GROUP_DETAILS].tab]: tab,
      },
    };
  }
</script>
